// src/algorithms/ordered/white-noise.ts

/** Generate an N x N white noise R8 texture. */
export function uploadWhiteNoiseTexture(
  gl: WebGL2RenderingContext, n = 256, seed = 0xc0ffee,
): { tex: WebGLTexture; size: number } {
  let s = seed;
  const data = new Uint8Array(n * n);
  for (let i = 0; i < data.length; i++) {
    s = (s * 1103515245 + 12345) | 0;
    data[i] = (s >>> 16) & 0xff;
  }
  const tex = gl.createTexture()!;
  gl.bindTexture(gl.TEXTURE_2D, tex);
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.R8, n, n, 0, gl.RED, gl.UNSIGNED_BYTE, data);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
  return { tex, size: n };
}

/** Build an N x N R8 white-noise byte array (no GL). Used as a blue-noise
 * fallback when the canonical asset is unavailable. */
export function whiteNoiseBytes(n = 256, seed = 0xc0ffee): Uint8Array {
  let s = seed;
  const data = new Uint8Array(n * n);
  for (let i = 0; i < data.length; i++) {
    s = (s * 1103515245 + 12345) | 0;
    data[i] = (s >>> 16) & 0xff;
  }
  return data;
}
